export default {
  sm: `
  데이터센터 각의 첨단기술은
  내일의 혁신을 위한
  필수 조건입니다.
  `,
  md: `
  데이터센터 각의 첨단기술은
  내일의 혁신을 위한 필수 조건입니다.    
  `,
};
